import PublicNavbar from "../components/PublicNavbar";

const About = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0B] relative overflow-hidden">
      <PublicNavbar />
      
      {/* Subtle background effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden>
        <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-[#D4AF37]/3 rounded-full blur-3xl"></div>
      </div>

      <main className="relative z-10 pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#FAFAFA] mb-6"
            style={{ fontFamily: "'Manrope', sans-serif" }}
            data-testid="about-title"
          >
            About <span className="text-gold-gradient">DopeInHD</span>
          </h1>
          
          <p className="text-lg md:text-xl text-[#A1A1AA] mb-8 leading-relaxed" data-testid="about-description">
            DopeInHD Incorporated is a multi-division media brand dedicated to amplifying artists 
            and creating premium content. We bring stories to life through high-definition visuals, 
            strategic marketing, and unmatched creative direction.
          </p>

          <div className="grid md:grid-cols-3 gap-8 mt-16">
            <div className="p-6 bg-[#121214] border border-[#27272A] rounded-xl">
              <h3 className="text-xl font-semibold text-[#D4AF37] mb-3">Our Vision</h3>
              <p className="text-[#A1A1AA] text-sm">
                To be the premier creative force in media production and artist promotion.
              </p>
            </div>
            <div className="p-6 bg-[#121214] border border-[#27272A] rounded-xl">
              <h3 className="text-xl font-semibold text-[#D4AF37] mb-3">Our Mission</h3>
              <p className="text-[#A1A1AA] text-sm">
                Empowering artists with world-class production and marketing services.
              </p>
            </div>
            <div className="p-6 bg-[#121214] border border-[#27272A] rounded-xl">
              <h3 className="text-xl font-semibold text-[#D4AF37] mb-3">Our Values</h3>
              <p className="text-[#A1A1AA] text-sm">
                Excellence, creativity, integrity, and relentless dedication to our craft.
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 text-center py-8 border-t border-[#27272A]">
        <p className="text-[#71717A] text-xs">
          © 2025 DopeInHD Incorporated. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default About;
